import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import { useSelector } from "react-redux";
import Loader from "../../../Loader/Loader";
import { Button, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import moment from "moment";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";

const SentimateReviewCount = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail
  );
  const [widgetModal, setWidgetModal] = useState(false);
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const [loading, setLoading] = useState(false);
  const [selfPropertyData, setSelfPropertyData] = useState(null);
  const [sentimateReviewData, setSentimateReviewData] = useState(null);
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const [tblids, settblids] = useState({
    sentimentalreview: commonService.GenerateGUID(),
  });
  const widgetDetailRef = useRef();
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty.defaultAsOfDate
  );
  const getSentimateReview = async () => {
    setLoading(true);
    let sentimateReviewResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.ANALYTICS.SENTIMATE_REVIEW_COUNT,
        body: {
          propertyCode: para?.propertyCode,
        },
      },
      false
    );

    let response = apiResponse(false, sentimateReviewResponse);

    if (response?.isValidate) {
      let findSelfPropertyData = response?.data?.data?.filter(
        (x) => x?.propertyname === propertyDetailFromRTK?.propertyname
      );
      setSelfPropertyData(findSelfPropertyData);
      setSentimateReviewData(response?.data?.data);
      setLoading(false);
    }

    if (!response?.isValidate) {
      setSelfPropertyData(null);
      setSentimateReviewData(null);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (api === 0) {
    } else {
      if (para?.propertyCode) {
        getSentimateReview();
      }
    }
  }, [para?.propertyCode]);

  return (
    <div>
      <div className="table__container mt-3 sentimental-review">
        <div className="stripped__table">
          {" "}
          {api !== 0 && (
            <div className=" widget-container-menu ">
              <Button
                className="heading-menu-btns heading-menu-btns-revpak"
                type="button"
                title="Send Mail"
              >
                <img id={commonService.generateGlobalClickTrackerID("SentimateReviewCount", "emailicon", propertyCode)}
                  src={emailIcon}
                  alt="emailIcon"
                  onClick={() => {
                    commonService.fnSendWidgetMail(
                      tblids.sentimentalreview,
                      "sentimental review",
                      snapshotId,
                      defaultAsOfDateFromRTK,
                      "",
                      para?.widgetId
                    );
                  }}
                />
              </Button>
              <Button
                className="heading-menu-btns heading-menu-btns-revpak"
                type="button"
              >
                <img id={commonService.generateGlobalClickTrackerID("SentimateReviewCount", "info", propertyCode)}
                  src={infoIcon}
                  alt="info"
                  onClick={() => {
                    widgetDetailRef.current = {
                      widgetdetails: "",
                      usernote: "",
                      compName: compName?.analyticsSentimateReview,
                      widgetId: para?.widgetId,
                    };
                    setWidgetModal(true);
                  }}
                />
              </Button>
              <Button
                className="heading-menu-btns heading-menu-btns-revpak"
                type="button"
              >
                <img id={commonService.generateGlobalClickTrackerID("SentimateReviewCount", "menuicon", propertyCode)}
                  src={downloadIcon}
                  alt="menuIcon"
                  import={tblids.sentimentalreview}
                  onClick={() =>
                    commonService.fnExportInCSV(
                      tblids.sentimentalreview,
                      // "Day By Day Channel"
                      `${para?.propertyCode}-sentimental review-${moment(
                        new Date()
                      ).format("MMDDYYYY")}`
                    )
                  }
                />
              </Button>
            </div>
          )}
          <div className="table-responsive">
            <Table id={tblids.sentimentalreview}>
              <thead className="tbl-header-sticky my-tbl-header-sticky">
                <tr>
                  <th>Property</th>
                  <th className="width100">Positive</th>
                  <th className="width100">Negative</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr style={{ height: "80px", position: "relative" }}>
                    <Loader />
                  </tr>
                ) : (
                  <>
                    {selfPropertyData?.length > 0 && (
                      <tr className="shadowOnHover">
                        <td className="fontBold">
                          {selfPropertyData?.[0]?.propertyname}
                        </td>
                        <td className="fontBold">
                          {selfPropertyData?.[0]?.positive_count}
                        </td>
                        <td className="fontBold">
                          {selfPropertyData?.[0]?.negative_count}
                        </td>
                      </tr>
                    )}
                    {sentimateReviewData?.map((item) => {
                      if (
                        item?.propertyname !==
                        propertyDetailFromRTK?.propertyname
                      ) {
                        return (
                          <tr
                            key={item?.propertyname}
                            className="shadowOnHover"
                          >
                            <td>{item?.propertyname}</td>
                            <td>{item?.positive_count}</td>
                            <td>{item?.negative_count}</td>
                          </tr>
                        );
                      }
                    })}
                  </>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default SentimateReviewCount;
